import { DropResult } from "react-beautiful-dnd";

export function dndReorder<T extends object>(dropResult: DropResult, orderedItems: ReadonlyArray<T>) {
  if (!dropResult.destination) return orderedItems;

  const startIndex = dropResult.source.index;
  const endIndex = dropResult.destination.index;
  const reorderedItems = [ ...orderedItems ];

  const movedItem = reorderedItems.splice(startIndex, 1)[0];
  reorderedItems.splice(endIndex, 0, movedItem);
  return reorderedItems;
}
